var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-iOS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iOS",
    clipPath: "url(#clip-iOS)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ios-svgrepo-com",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4564",
    "data-name": "Path 4564",
    d: "M22,12A10,10,0,1,1,12,2,10,10,0,0,1,22,12Z",
    fill: "#2e78d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4565",
    "data-name": "Path 4565",
    d: "M7.06,17.893H8.131v-4.97H7.06Zm.533-5.622A.637.637,0,1,0,7,11.638.614.614,0,0,0,7.594,12.271Z",
    transform: "translate(-1.424 -2.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4566",
    "data-name": "Path 4566",
    d: "M12.7,11.02c-1.811,0-2.947,1.346-2.947,3.5s1.136,3.493,2.947,3.493,2.942-1.341,2.942-3.493S14.5,11.02,12.7,11.02Zm0,1.032c1.106,0,1.811.957,1.811,2.466S13.8,16.98,12.7,16.98s-1.811-.956-1.811-2.462S11.588,12.052,12.7,12.052Z",
    transform: "translate(-2.169 -2.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4567",
    "data-name": "Path 4567",
    d: "M19.061,16a2.13,2.13,0,0,0,2.413,2.016c1.5,0,2.448-.807,2.448-2.091,0-1.008-.533-1.575-1.794-1.89l-.714-.178c-.761-.2-1.075-.459-1.075-.91,0-.563.473-.938,1.174-.938a1.118,1.118,0,0,1,1.248,1.013h1.058a2.066,2.066,0,0,0-2.3-2,2.077,2.077,0,0,0-2.31,2.012c0,.966.542,1.566,1.686,1.852l.8.206c.783.2,1.1.483,1.1.971,0,.563-.521.966-1.269.966A1.271,1.271,0,0,1,20.136,16Z",
    transform: "translate(-4.724 -2.508)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOs);
export default __webpack_public_path__ + "static/media/iOS.f34585133f28433525bc41f913c4e615.svg";
export { ForwardRef as ReactComponent };